import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=11ac268e"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ac268e')) {
      api.createRecord('11ac268e', component.options)
    } else {
      api.reload('11ac268e', component.options)
    }
    module.hot.accept("./notifications.vue?vue&type=template&id=11ac268e", function () {
      api.rerender('11ac268e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/settings/notifications.vue"
export default component.exports